<template>
  <b-card class="dashboard__tab-content-card">
    <b-row class="match-height">
      <b-col :md="(fileInfo && ['Niche', 'Little Buddha', 'Pedestal'].includes(fileInfo.nvsFileType)) ? 4 : 6">
        <b-card
          class="has-padding"
        >
          <b-card-title>
            File Details
          </b-card-title>
          <b-card-body>
            <b-table-simple
              borderless
              responsive
              class="particulars_of_deceased d-none d-md-block"
            >
              <b-tbody>
                <b-tr>
                  <b-th width="230px">
                    File No.
                  </b-th>
                  <b-td>{{ fileInfo.fileNo ? fileInfo.fileNo : '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Booking Date
                  </b-th>
                  <b-td>{{ fileInfo.bookingDate ? dateFormat(fileInfo.bookingDate) : '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Confirm Date
                  </b-th>
                  <b-td>{{ fileInfo.confirmDate ? dateFormat(fileInfo.confirmDate) : '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Confirmed By
                  </b-th>
                  <b-td>{{ fileInfo.confirmedBy ? fileInfo.confirmedBy : '-' }}</b-td>
                </b-tr>
                <b-tr v-if="['Niche'].includes(fileInfo.nvsFileType)">
                  <b-th width="230px">
                    Exercise Date
                  </b-th>
                  <b-td>{{ fileInfo.exerciseDate ? dateFormat(fileInfo.exerciseDate) : '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Product Description
                  </b-th>
                  <b-td>{{ fileInfo.nvsFileType ? fileInfo.nvsFileType : '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Payment Method
                  </b-th>
                  <b-td>{{ (fileInfo.ledgerSummary && fileInfo.ledgerSummary.paymentMethod) ? fileInfo.ledgerSummary.paymentMethod : '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Customer Type
                  </b-th>
                  <b-td class="text-capitalize">
                    {{ fileInfo.customerType ? fileInfo.customerType.toLowerCase() : '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Need Type
                  </b-th>
                  <b-td>{{ fileInfo.needType ? fileInfo.needType : '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Bury At NV
                  </b-th>
                  <b-td>{{ fileInfo.buryAtNV ? fileInfo.buryAtNV : '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Purchase Order No.
                  </b-th>
                  <b-td>{{ fileInfo.poNo ? fileInfo.poNo : '-' }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>

            <hr>

            <div>
              <h4 class="fs-18 weight-500 my-50 black-color">
                File Transfer Details
              </h4>
              <b-row>
                <b-col
                  class="content-header-left"
                  cols="5"
                  md="5"
                  sm="5"
                  lg="5"
                >
                  <h5 class="font-weight-bolder black-color">
                    File Transfer Date
                  </h5>
                </b-col>
                <b-col
                  class="content-header-left"
                  cols="4"
                  md="4"
                  sm="4"
                  lg="4"
                >
                  <p>{{ fileInfo.fileTransferDate ? dateFormat(fileInfo.fileTransferDate) : '-' }}</p>
                </b-col>
                <b-col
                  class="content-header-left text-right"
                  cols="3"
                  md="3"
                  sm="3"
                  lg="3"
                >
                  <b-button
                    v-if="canViewThisAction('update-transfer-date', 'File')"
                    v-b-tooltip.hover.top="'Edit Date'"
                    variant="flat-primary"
                    class="edit_remark_button"
                    @click="editTransferDate"
                  >
                    <feather-icon
                      class="cursor-pointer"
                      icon="EditIcon"
                      size="16"
                    />
                  </b-button>
                </b-col>
              </b-row>
            </div>

            <hr>

            <div>
              <h5 class="font-weight-bolder black-color">
                Remarks
              </h5>
              <b-row>
                <b-col
                  class="content-header-left"
                  cols="9"
                  md="9"
                  sm="9"
                  lg="10"
                >
                  <p>{{ fileInfo.remarks ? fileInfo.remarks : '' }}</p>
                </b-col>
                <b-col
                  class="content-header-left text-right"
                  cols="3"
                  md="3"
                  sm="3"
                  lg="2"
                >
                  <b-button
                    v-if="canViewThisAction('update', 'File')"
                    v-b-tooltip.hover.top="'Edit Remarks'"
                    variant="flat-primary"
                    class="edit_remark_button"
                    @click="editRemarks"
                  >
                    <feather-icon
                      class="cursor-pointer"
                      icon="EditIcon"
                      size="16"
                    />
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col :md="(fileInfo && ['Niche', 'Little Buddha', 'Pedestal'].includes(fileInfo.nvsFileType)) ? 4 : 6">
        <b-card
          class="has-padding"
        >
          <b-card-header
            v-if="['Niche', 'Funeral Service Package', 'Pedestal'].includes(fileInfo.nvsFileType)"
            class="pt-0 no-bottom-border"
          >
            <b-card-title class="mr-auto">
              Purchaser Details
            </b-card-title>
            <b-dropdown
              variant="link"
              no-caret
              class="chart-dropdown"
              toggle-class="p-0"
              right
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item
                :disabled="['OPEN', 'CONFIRM/Exercise'].includes(fileInfo.nvsFileStatus) || !canViewThisAction('allow-transfer', 'File')"
                @click="allowTransfer"
              >
                Allow Transfer Override
              </b-dropdown-item>
              <!-- <b-dropdown-item
                :disabled="(fileInfo.nvsFileType == 'Funeral Service Package' && fileInfo.nvsFileStatus == 'CONFIRM/Exercise') || fileInfo.nvsFileStatus != 'CONFIRM/Exercise' || ['OPEN'].includes(fileInfo.nvsFileStatus) || !canViewThisAction('allow-transfer-when-exercised', 'File')"
                @click="allowExercisedTransfer"
              >
                Enable/disable Transferable When Exercised
              </b-dropdown-item> -->
            </b-dropdown>
          </b-card-header>
          <b-card-title v-else>
            Purchaser Details
          </b-card-title>
          <b-card-body>
            <b-table-simple
              v-if="['Niche', 'Funeral Service Package', 'Pedestal'].includes(fileInfo.nvsFileType)"
              borderless
              responsive
              class="particulars_of_deceased d-none d-md-block"
            >
              <b-tbody>
                <b-tr>
                  <b-th width="230px">
                    Transferable
                    <b-button
                      v-b-tooltip.hover.top="'By default, only fully paid files are transferable. Selected users can override this, allowing this file to be transferable.'"
                      variant="none"
                      class="p-0"
                    >
                      <feather-icon
                        icon="InfoIcon"
                      />
                    </b-button>
                  </b-th>
                  <b-td class="text-right">
                    <span v-if="!['OPEN'].includes(fileInfo.nvsFileStatus) && fileInfo.paymentStatus == 'Fully Paid' && !fileInfo.transferableUntil">
                      Always
                    </span>
                    <span v-else-if="!['OPEN'].includes(fileInfo.nvsFileStatus) && fileInfo.transferableUntil">
                      Until {{ dateFormat(fileInfo.transferableUntil) }}
                    </span>
                    <span v-else>
                      No
                    </span>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Transferable If Exercised
                  </b-th>
                  <b-td class="text-right">
                    {{ fileInfo.exercisedTransferable ? 'Yes' : 'No' }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <b-tabs
              v-if="purchasersData && purchasersData.length"
              class="purchaser-tabs"
              content-class="mt-2"
            >
              <b-tab
                v-for="(purchaser, key) in purchasersData"
                :key="'purchaser' + key"
                :title="'PCR #' + (key + 1)"
              >
                <b-card-text>
                  <b-table-simple
                    borderless
                    responsive
                    class="particulars_of_deceased d-none d-md-block"
                  >
                    <b-tbody>
                      <b-tr>
                        <b-th width="230px">
                          Purchaser Name
                        </b-th>
                        <b-td>
                          <b-button
                            v-if="canViewThisAction('show', 'Customer') && purchaser.customer"
                            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                            variant="link"
                            class="weight-600 align-middle detail-view-id text-uppercase"
                            :to="{ name: 'customers-customers-show', params: { id: purchaser.customer._id } }"
                          >
                            {{ purchaser.name }}
                          </b-button>
                          <b-button
                            v-else
                            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                            variant="none"
                            class="text-bold-black align-middle not-button text-uppercase"
                          >
                            {{ purchaser.name }}
                          </b-button>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          NRIC
                        </b-th>
                        <b-td class="text-uppercase">
                          <div v-if="purchaser.showFullNric">
                            <span class="mr-50">{{ purchaser.nric }}</span>
                            <b-button
                              variant="primary"
                              size="sm"
                              class="px-50"
                              @click="purchaser.showFullNric = false"
                            >
                              Hide full NRIC
                            </b-button>
                          </div>
                          <div v-else>
                            <span class="mr-50">{{ purchaser.encryptedNric || '-' }}</span>
                            <b-button
                              v-if="canViewThisAction('view-nric', 'NRIC') && purchaser.nric"
                              variant="primary"
                              size="sm"
                              class="px-50"
                              @click="purchaser.showFullNric = true"
                            >
                              Show full NRIC
                            </b-button>
                          </div>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Date of Birth
                        </b-th>
                        <b-td>{{ (purchaser.customer && purchaser.customer.dob) ? dateFormat(purchaser.customer.dob) : '-' }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Sex
                        </b-th>
                        <b-td class="text-uppercase">
                          {{ (purchaser.customer && purchaser.customer.sex) ? purchaser.customer.sex : '-' }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Race
                        </b-th>
                        <b-td class="text-uppercase">
                          {{ (purchaser.customer && purchaser.customer.race) ? purchaser.customer.race : '-' }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Nationality
                        </b-th>
                        <b-td class="text-uppercase">
                          {{ (purchaser.customer && purchaser.customer.nationality) ? purchaser.customer.nationality : '-' }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Mobile No.
                        </b-th>
                        <b-td>{{ purchaser.contact ? purchaser.contact : '-' }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Email Address
                        </b-th>
                        <b-td class="">
                          {{ purchaser.email ? purchaser.email : '-' }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Residential Address
                        </b-th>
                        <b-td>
                          {{ getResidentialAddress(purchaser) }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Nirvana SG User
                        </b-th>
                        <b-td>{{ (purchaser.customer && purchaser.customer.password) ? 'Yes' : 'No' }}</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        v-if="(fileInfo && ['Niche', 'Little Buddha', 'Pedestal'].includes(fileInfo.nvsFileType))"
        :md="(fileInfo && ['Niche', 'Little Buddha', 'Pedestal'].includes(fileInfo.nvsFileType)) ? 4 : 6"
      >
        <b-card
          class="has-padding"
        >
          <b-card-title>
            Lot Details
          </b-card-title>
          <b-card-body>
            <b-table-simple
              borderless
              responsive
              class="particulars_of_deceased d-none d-md-block"
            >
              <b-tbody>
                <b-tr>
                  <b-th width="230px">
                    Zone No.
                  </b-th>
                  <b-td>{{ relatedLot.zoneNo || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Lot No.
                  </b-th>
                  <b-td>{{ relatedLot.lotNo || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Lot Type
                  </b-th>
                  <b-td>{{ relatedLot.lotType || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Bury Capacity
                  </b-th>
                  <b-td>{{ relatedLot.buryCapacity || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Area Length
                  </b-th>
                  <b-td>{{ relatedLot.areaLength || '-' }}</b-td>
                </b-tr>
                <b-tr v-if="!['Little Buddha', 'Pedestal'].includes(fileInfo.nvsFileType)">
                  <b-th width="230px">
                    Direction
                  </b-th>
                  <b-td>{{ relatedLot.direction || '-' }}</b-td>
                </b-tr>
                <b-tr v-if="!['Little Buddha', 'Pedestal'].includes(fileInfo.nvsFileType)">
                  <b-th width="230px">
                    Side
                  </b-th>
                  <b-td>{{ relatedLot.side || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Level No.
                  </b-th>
                  <b-td>{{ relatedLot.levelNo || '-' }}</b-td>
                </b-tr>
                <b-tr v-if="!['Little Buddha', 'Pedestal'].includes(fileInfo.nvsFileType)">
                  <b-th width="230px">
                    Section No.
                  </b-th>
                  <b-td>{{ relatedLot.section || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Land Category
                  </b-th>
                  <b-td>{{ relatedLot.lotCategory || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Interment Date
                  </b-th>
                  <b-td>{{ relatedLot.intermentDate ? dateFormat(relatedLot.intermentDate) : '-' }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>

            <hr>

            <div>
              <h5 class="font-weight-bolder black-color">
                Remarks
              </h5>
              <b-row>
                <b-col
                  class="content-header-left"
                  cols="12"
                  md="12"
                >
                  <p>{{ relatedLot.remarks || '-' }}</p>
                </b-col>
              </b-row>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row
      v-if="fileInfo && fileInfo.nvsFileType != 'Little Buddha'"
      class="match-height"
    >
      <b-col
        v-if="fileInfo.nvsFileType != 'Urn'"
        md="4"
      >
        <b-card
          class="has-padding"
        >
          <b-card-title>
            <div class="d-flex">
              <span>Notice of Full Payment</span>
              <b-button
                v-if="canViewThisAction('download-certificate', 'File') && (fileInfo && ['Niche', 'Funeral Service Package', 'Pedestal'].includes(fileInfo.nvsFileType))"
                variant="link"
                :disabled="fileInfo.paymentStatus !== 'Fully Paid' || !['CONFIRM', 'CONFIRM/Exercise', 'CONFIRM/Redeem'].includes(fileInfo.nvsFileStatus)"
                class="ml-auto pt-0"
                @click="downloadNoticeOfFullPayment"
              >
                Download
                <feather-icon icon="DownloadIcon" />
              </b-button>
            </div>
          </b-card-title>
          <b-card-body>
            <b-tabs
              v-if="fileInfo.paymentStatus === 'Fully Paid' && !fileInfo.isNewCertificate"
              class="purchaser-tabs"
              content-class="mt-2"
            >
              <b-tab
                title="Certificate Details"
              >
                <b-card-text>
                  <b-table-simple
                    borderless
                    responsive
                    class="particulars_of_deceased d-none d-md-block"
                  >
                    <b-tbody>
                      <b-tr>
                        <b-th width="230px">
                          Cert No
                        </b-th>
                        <b-td>
                          {{ fileInfo.certificate ? (fileInfo.certificate.certificateNo ? `${fileInfo.certificate.certificateNo}${fileInfo.certificate.certificateTransferNo ? `-${fileInfo.certificate.certificateTransferNo}` : ''}` : '-') : '-' }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Batch No.
                        </b-th>
                        <b-td>{{ fileInfo.certificate ? (fileInfo.certificate.batchNo ? fileInfo.certificate.batchNo : '-') : '-' }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Cert Date
                        </b-th>
                        <b-td>{{ fileInfo.certificate ? (fileInfo.certificate.certificateDate ? dateFormat(fileInfo.certificate.certificateDate) : '-') : '-' }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Send Date
                        </b-th>
                        <b-td>{{ fileInfo.certificate ? (fileInfo.certificate.sendDate ? dateFormat(fileInfo.certificate.sendDate) : '-') : '-' }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Receive Date
                        </b-th>
                        <b-td>{{ fileInfo.certificate ? (fileInfo.certificate.receiveDate ? dateFormat(fileInfo.certificate.receiveDate) : '-') : '-' }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Issue Date
                        </b-th>
                        <b-td>{{ fileInfo.certificate ? (fileInfo.certificate.issueDate ? dateFormatWithFormatNTZ(fileInfo.certificate.issueDate, 'DD/MM/YYYY, hh:mm:ssa') : '-') : '-' }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Delivery Method
                        </b-th>
                        <b-td>
                          <span>
                            {{ fileInfo.certificate ? (fileInfo.certificate.deliveryMethod ? fileInfo.certificate.deliveryMethod : '-') : '-' }}
                          </span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Delivery Status
                        </b-th>
                        <b-td>
                          <span class="text-success weight-500">
                            {{ fileInfo.certificate ? (fileInfo.certificate.deliveryStatus ? fileInfo.certificate.deliveryStatus : '-') : '-' }}
                          </span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Cert Transfer Date
                        </b-th>
                        <b-td>{{ fileInfo.certificate ? (fileInfo.certificate.certificateTransferDate ? dateFormat(fileInfo.certificate.certificateTransferDate) : '-') : '-' }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Cert Duplicate Date
                        </b-th>
                        <b-td>{{ fileInfo.certificate ? (fileInfo.certificate.certificateDuplicateDate ? dateFormat(fileInfo.certificate.certificateDuplicateDate) : '-') : '-' }}</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>

                  <hr>

                  <div>
                    <h5 class="font-weight-bolder black-color">
                      Remarks
                    </h5>
                    <b-row>
                      <b-col
                        class="content-header-left"
                        cols="12"
                        md="12"
                      >
                        <p>{{ fileInfo.certificate ? (fileInfo.certificate.remarks ? fileInfo.certificate.remarks : '-') : '-' }}</p>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-text>
              </b-tab>
            </b-tabs>
            <b-card-text
              v-else-if="fileInfo.paymentStatus === 'Fully Paid' && fileInfo.isNewCertificate"
            >
              <b-table-simple
                borderless
                responsive
                class="particulars_of_deceased d-none d-md-block"
              >
                <b-tbody>
                  <b-tr>
                    <b-th width="230px">
                      Issue Date
                    </b-th>
                    <b-td>{{ fileInfo.certificateIssueDate ? dateFormatWithFormatNTZ(fileInfo.certificateIssueDate, 'DD/MM/YYYY, hh:mm:ssa') : '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Delivery Method
                    </b-th>
                    <b-td>
                      <span>
                        Digital
                      </span>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>

              <hr>

              <div>
                <h5 class="font-weight-bolder black-color">
                  Remarks
                </h5>
                <b-row>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <p>{{ fileInfo.certificate ? (fileInfo.certificate.remarks ? fileInfo.certificate.remarks : '-') : '-' }}</p>
                  </b-col>
                </b-row>
              </div>
            </b-card-text>
            <b-card-text
              v-else
            >
              <div class="empty_block">
                <h4>Pending Full Payment</h4>
                <span class="align-middle">Notice of Full Payment is only available after the file has been fully paid.</span>
              </div>
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col :md="fileInfo.nvsFileType == 'Urn' ? 12 : 8">
        <b-card
          class="has-padding"
        >
          <b-card-title>
            Related Nominees
          </b-card-title>
          <b-card-body>
            <b-tabs
              class="purchaser-tabs"
              content-class="mt-2"
            >
              <b-tab
                v-if="!['Urn', 'Pedestal', 'Little Buddha'].includes(fileInfo.nvsFileType)"
                :title="'Intended User ' + (intendedUsersData ? (`(${intendedUsersData.length})`) : '(0)')"
              >
                <b-card-text>
                  <b-row
                    v-if="fileInfo && intendedUsersData && intendedUsersData.length"
                    class="match-height"
                  >
                    <b-col
                      v-for="(iu, key) in intendedUsersData.slice(0, 2)"
                      :key="'iu' + key"
                      md="6"
                    >
                      <b-card
                        class="card-transaction iu-card"
                        no-body
                      >
                        <b-card-header class="no-bottom-border">
                          <b-card-title>Intended User #{{ key + 1 }}</b-card-title>
                          <b-button
                            variant="none"
                            class="btn-icon rounded-circle ml-auto mr-1 flat-primary-bg"
                          >
                            <feather-icon icon="UserIcon" />
                          </b-button>
                          <b-dropdown
                            variant="link"
                            no-caret
                            class="chart-dropdown"
                            toggle-class="p-0"
                            right
                          >
                            <template #button-content>
                              <feather-icon
                                icon="MoreVerticalIcon"
                                size="18"
                                class="text-body cursor-pointer"
                              />
                            </template>
                            <b-dropdown-item
                              v-if="canViewThisAction('nominee-edit', 'File')"
                              @click="editUser(iu, key)"
                            >
                              Edit
                            </b-dropdown-item>
                            <b-dropdown-item
                              v-if="canViewThisAction('nominee-delete', 'File')"
                              @click="removeUser(iu, key)"
                            >
                              Remove
                            </b-dropdown-item>
                          </b-dropdown>
                        </b-card-header>
                        <b-card-body>
                          <b-button
                            v-if="canViewThisAction('show', 'Customer') && iu.customer"
                            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                            variant="link"
                            class="weight-600 align-middle detail-view-id text-uppercase"
                            :to="{ name: 'customers-customers-show', params: { id: iu.customer._id } }"
                          >
                            {{ iu.name }}
                          </b-button>
                          <b-button
                            v-else
                            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                            variant="none"
                            class="text-bold-black align-middle not-button text-uppercase"
                          >
                            {{ iu.name }}
                          </b-button>
                          <b-badge
                            v-if="iu.isPurchaser"
                            variant="light-info"
                            class="ml-50"
                          >
                            {{ iu.purchaserNo }}
                          </b-badge>
                          <br>
                          <div v-if="iu.showFullNric">
                            <span class="text-uppercase mr-50">{{ iu.nric }}</span>
                            <b-button
                              variant="primary"
                              size="sm"
                              class="px-50"
                              @click="iu.showFullNric = false"
                            >
                              Hide full NRIC
                            </b-button>
                          </div>
                          <div v-else>
                            <span class="text-uppercase mr-50">{{ iu.encryptedNric || '-' }}</span>
                            <b-button
                              v-if="canViewThisAction('view-nric', 'NRIC') && iu.nric"
                              variant="primary"
                              size="sm"
                              class="px-50"
                              @click="iu.showFullNric = true"
                            >
                              Show full NRIC
                            </b-button>
                          </div>
                          <span class="text-uppercase">{{ iu.relation || '-' }}</span>
                          <br>
                          <span>
                            <feather-icon
                              icon="TabletIcon"
                              size="22"
                              class="mr-25 iu-icon"
                            />
                            {{ iu.contact || '-' }}
                          </span>
                          <br>
                          <span>
                            <b-img
                              height="22"
                              :src="require('@/assets/images/admin/birthday.png')"
                              alt="Left image"
                              class="mr-25"
                            />
                            <!-- {{ (iu.customer && iu.customer.dob) ? dateFormat(iu.customer.dob) : '-' }} -->
                            {{ iu.dob ? dateFormat(iu.dob) : '-' }}
                          </span>
                          <br>
                          <span>
                            <feather-icon
                              icon="MapPinIcon"
                              size="22"
                              class="mr-25 iu-icon"
                            />
                            <span>
                              {{ getNomineeResidentialAddress(iu) }}
                            </span>
                          </span>
                        </b-card-body>
                      </b-card>
                    </b-col>
                  </b-row>
                  <div
                    v-else
                    class="empty_block"
                  >
                    <h4>No Data Yet</h4>
                    <span class="align-middle">Item will show once the data is entered</span>
                  </div>
                </b-card-text>
              </b-tab>
              <b-tab :title="'Next of Kin ' + (nextOfKinsData ? (`(${nextOfKinsData.length})`) : '(0)')">
                <b-card-text>
                  <b-row
                    v-if="fileInfo && nextOfKinsData && nextOfKinsData.length"
                    class="match-height"
                  >
                    <b-col
                      v-for="(iu, key) in nextOfKinsData.slice(0, 2)"
                      :key="'iu' + key"
                      md="6"
                    >
                      <b-card
                        class="card-transaction iu-card"
                        no-body
                      >
                        <b-card-header class="no-bottom-border">
                          <b-card-title>Next of Kin #{{ key + 1 }}</b-card-title>
                          <b-button
                            variant="none"
                            class="btn-icon rounded-circle ml-auto mr-1 flat-primary-bg"
                          >
                            <feather-icon icon="UserIcon" />
                          </b-button>
                          <b-dropdown
                            variant="link"
                            no-caret
                            class="chart-dropdown"
                            toggle-class="p-0"
                            right
                          >
                            <template #button-content>
                              <feather-icon
                                icon="MoreVerticalIcon"
                                size="18"
                                class="text-body cursor-pointer"
                              />
                            </template>
                            <b-dropdown-item
                              v-if="canViewThisAction('nominee-edit', 'File')"
                              @click="editUser(iu, key)"
                            >
                              Edit
                            </b-dropdown-item>
                            <b-dropdown-item
                              v-if="canViewThisAction('nominee-delete', 'File')"
                              @click="removeUser(iu, key)"
                            >
                              Remove
                            </b-dropdown-item>
                          </b-dropdown>
                        </b-card-header>
                        <b-card-body>
                          <b-button
                            v-if="canViewThisAction('show', 'Customer') && iu.customer"
                            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                            variant="link"
                            class="weight-600 align-middle detail-view-id text-uppercase"
                            :to="{ name: 'customers-customers-show', params: { id: iu.customer._id } }"
                          >
                            {{ iu.name }}
                          </b-button>
                          <b-button
                            v-else
                            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                            variant="none"
                            class="text-bold-black align-middle not-button text-uppercase"
                          >
                            {{ iu.name }}
                          </b-button>
                          <b-badge
                            v-if="iu.isPurchaser"
                            variant="light-info"
                            class="ml-50"
                          >
                            {{ iu.purchaserNo }}
                          </b-badge>
                          <br>
                          <div v-if="iu.showFullNric">
                            <span class="text-uppercase mr-50">{{ iu.nric }}</span>
                            <b-button
                              variant="primary"
                              size="sm"
                              class="px-50"
                              @click="iu.showFullNric = false"
                            >
                              Hide full NRIC
                            </b-button>
                          </div>
                          <div v-else>
                            <span class="text-uppercase mr-50">{{ iu.encryptedNric || '-' }}</span>
                            <b-button
                              v-if="canViewThisAction('view-nric', 'NRIC') && iu.nric"
                              variant="primary"
                              size="sm"
                              class="px-50"
                              @click="iu.showFullNric = true"
                            >
                              Show full NRIC
                            </b-button>
                          </div>
                          <span class="text-uppercase">{{ iu.relation || '-' }}</span>
                          <br>
                          <span>
                            <feather-icon
                              icon="TabletIcon"
                              size="22"
                              class="mr-25 iu-icon"
                            />
                            {{ iu.contact || '-' }}
                          </span>
                          <br>
                          <span>
                            <b-img
                              height="22"
                              :src="require('@/assets/images/admin/birthday.png')"
                              alt="Left image"
                              class="mr-25"
                            />
                            <!-- {{ (iu.customer && iu.customer.dob) ? dateFormat(iu.customer.dob) : '-' }} -->
                            {{ iu.dob ? dateFormat(iu.dob) : '-' }}
                          </span>
                          <br>
                          <span>
                            <feather-icon
                              icon="MapPinIcon"
                              size="22"
                              class="mr-25 iu-icon"
                            />
                            <span>
                              {{ getNomineeResidentialAddress(iu) }}
                            </span>
                          </span>
                        </b-card-body>
                      </b-card>
                    </b-col>
                  </b-row>
                  <div
                    v-else
                    class="empty_block"
                  >
                    <h4>No Data Yet</h4>
                    <span class="align-middle">Item will show once the data is entered</span>
                  </div>
                </b-card-text>
              </b-tab>
              <b-tab :title="'Addressee ' + (addresseeData ? (`(${addresseeData.length})`) : '(0)')">
                <b-card-text>
                  <b-row
                    v-if="fileInfo && addresseeData && addresseeData.length"
                    class="match-height"
                  >
                    <b-col
                      v-for="(iu, key) in addresseeData.slice(0, 2)"
                      :key="'iu' + key"
                      md="6"
                    >
                      <b-card
                        class="card-transaction iu-card"
                        no-body
                      >
                        <b-card-header class="no-bottom-border">
                          <b-card-title>Addressee #{{ key + 1 }}</b-card-title>
                          <b-button
                            variant="none"
                            class="btn-icon rounded-circle ml-auto mr-1 flat-primary-bg"
                          >
                            <feather-icon icon="UserIcon" />
                          </b-button>
                          <b-dropdown
                            variant="link"
                            no-caret
                            class="chart-dropdown"
                            toggle-class="p-0"
                            right
                          >
                            <template #button-content>
                              <feather-icon
                                icon="MoreVerticalIcon"
                                size="18"
                                class="text-body cursor-pointer"
                              />
                            </template>
                            <b-dropdown-item
                              v-if="canViewThisAction('nominee-edit', 'File')"
                              @click="editUser(iu, key)"
                            >
                              Edit
                            </b-dropdown-item>
                            <b-dropdown-item
                              v-if="canViewThisAction('nominee-delete', 'File')"
                              @click="removeUser(iu, key)"
                            >
                              Remove
                            </b-dropdown-item>
                          </b-dropdown>
                        </b-card-header>
                        <b-card-body>
                          <b-button
                            v-if="canViewThisAction('show', 'Customer') && iu.customer"
                            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                            variant="link"
                            class="weight-600 align-middle detail-view-id text-uppercase"
                            :to="{ name: 'customers-customers-show', params: { id: iu.customer._id } }"
                          >
                            {{ iu.name }}
                          </b-button>
                          <b-button
                            v-else
                            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                            variant="none"
                            class="text-bold-black align-middle not-button text-uppercase"
                          >
                            {{ iu.name }}
                          </b-button>
                          <b-badge
                            v-if="iu.isPurchaser"
                            variant="light-info"
                            class="ml-50"
                          >
                            {{ iu.purchaserNo }}
                          </b-badge>
                          <br>
                          <div v-if="iu.showFullNric">
                            <span class="text-uppercase mr-50">{{ iu.nric }}</span>
                            <b-button
                              variant="primary"
                              size="sm"
                              class="px-50"
                              @click="iu.showFullNric = false"
                            >
                              Hide full NRIC
                            </b-button>
                          </div>
                          <div v-else>
                            <span class="text-uppercase mr-50">{{ iu.encryptedNric || '-' }}</span>
                            <b-button
                              v-if="canViewThisAction('view-nric', 'NRIC') && iu.nric"
                              variant="primary"
                              size="sm"
                              class="px-50"
                              @click="iu.showFullNric = true"
                            >
                              Show full NRIC
                            </b-button>
                          </div>
                          <span class="text-uppercase">{{ iu.relation || '-' }}</span>
                          <br>
                          <span>
                            <feather-icon
                              icon="TabletIcon"
                              size="22"
                              class="mr-25 iu-icon"
                            />
                            {{ iu.contact || '-' }}
                          </span>
                          <br>
                          <span>
                            <b-img
                              height="22"
                              :src="require('@/assets/images/admin/birthday.png')"
                              alt="Left image"
                              class="mr-25"
                            />
                            <!-- {{ (iu.customer && iu.customer.dob) ? dateFormat(iu.customer.dob) : '-' }} -->
                            {{ iu.dob ? dateFormat(iu.dob) : '-' }}
                          </span>
                          <br>
                          <span>
                            <feather-icon
                              icon="MapPinIcon"
                              size="22"
                              class="mr-25 iu-icon"
                            />
                            <span>
                              {{ getNomineeResidentialAddress(iu) }}
                            </span>
                          </span>
                        </b-card-body>
                      </b-card>
                    </b-col>
                  </b-row>
                  <div
                    v-else
                    class="empty_block"
                  >
                    <h4>No Data Yet</h4>
                    <span class="align-middle">Item will show once the data is entered</span>
                  </div>
                </b-card-text>
              </b-tab>
              <template #tabs-end>
                <div class="text-right ml-auto vendor-detail-more-icon view-more-icon">
                  <b-button
                    variant="link"
                    :to="{ name: 'customers-files-nominees', params: { id: $route.params.id } }"
                  >
                    View more <feather-icon icon="ArrowRightIcon" />
                  </b-button>
                </div>
              </template>
            </b-tabs>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row
      class="match-height"
    >
      <b-col
        v-if="['Niche', 'Pedestal', 'Funeral Service Package'].includes(fileInfo.nvsFileType)"
        md="8"
      >
        <b-card
          class="has-padding"
        >
          <b-card-title>
            <div class="d-flex">
              <span class="mr-auto">Exercised For Person</span>
              <b-button
                v-if="canViewThisAction('add-exercised-for', 'File') && ['Niche', 'Pedestal', 'Funeral Service Package'].includes(fileInfo.nvsFileType) && fileInfo.maxDeceasedUser > exercisedForData.length"
                variant="link"
                :disabled="(fileInfo.nvsFileStatus == 'OPEN' || fileInfo.nvsFileStatus == 'BOOK') && !fileInfo.isAllowedExercising"
                class="pt-0"
                @click="addExercisedFor"
              >
                Add
                <feather-icon icon="PlusIcon" />
              </b-button>
              <b-button
                v-else-if="canViewThisAction('add-exercised-for', 'File') && ['Niche', 'Pedestal', 'Funeral Service Package'].includes(fileInfo.nvsFileType)"
                v-b-tooltip.hover="'You’ve reached the maximum number of exercised for person for this file.'"
                variant="link"
                class="pt-0"
                style="opacity: 0.65;"
                aria-readonly=""
              >
                Add
                <feather-icon icon="PlusIcon" />
              </b-button>
              <b-button
                v-if="exercisedForData && exercisedForData.length"
                variant="link"
                class="pt-0"
                :to="{ name: 'customers-files-deceased', params: { id: $route.params.id } }"
              >
                View all ({{ exercisedForData.length }})
                <feather-icon icon="ArrowRightIcon" />
              </b-button>
            </div>
          </b-card-title>
          <b-card-body>
            <b-alert
              v-if="showConfirmAlert(fileInfo.nvsFileType, fileInfo.confirmDate)"
              variant="warning"
              show
              class="warning__alert"
            >
              <div class="alert-body has-radius">
                <span>
                  This Funeral Service Package (Pre-Need) file was confirmed less than 30 days ago.
                </span>
              </div>
            </b-alert>
            <b-alert
              v-if="fileInfo.nvsFileStatus == 'BOOK'"
              variant="warning"
              show
              class="warning__alert"
            >
              <div class="alert-body has-radius">
                <div
                  v-if="fileInfo.isAllowedExercising"
                  class="d-flex"
                >
                  <span>This file is enabled for exercising even though it is on Book status.</span>
                  <b-button
                    v-if="canViewThisAction('disallow-exercising', 'File')"
                    variant="link"
                    class="p-0 underline ml-auto"
                    @click="disallowExercising"
                  >
                    Disallow exercising
                  </b-button>
                </div>
                <div
                  v-else
                  class="d-flex"
                >
                  <span>By default, files with Book status cannot be exercised.</span>
                  <b-button
                    v-if="canViewThisAction('allow-exercising', 'File')"
                    variant="link"
                    class="p-0 underline ml-auto"
                    @click="allowExercising"
                  >
                    Allow exercising anyway
                  </b-button>
                </div>
              </div>
            </b-alert>
            <b-card-text v-if="exercisedForData && exercisedForData.length">
              <b-row
                class="match-height"
              >
                <b-col
                  v-for="(iu, key) in exercisedForData.slice(0, 2)"
                  :key="'iu' + key"
                  :md="exercisedForData.length > 1 ? 6 : 12"
                >
                  <b-card
                    class="card-transaction iu-card exercised-for-card"
                    no-body
                  >
                    <b-card-header class="no-bottom-border">
                      <b-card-title>Exercised for (#{{ key + 1 }})</b-card-title>
                      <b-dropdown
                        variant="link"
                        no-caret
                        class="chart-dropdown"
                        toggle-class="p-0"
                        right
                      >
                        <template #button-content>
                          <feather-icon
                            icon="MoreVerticalIcon"
                            size="18"
                            class="text-body cursor-pointer"
                          />
                        </template>
                        <b-dropdown-item
                          v-if="canViewThisAction('edit-exercised-for', 'File')"
                          @click="editExercisedFor(iu)"
                        >
                          Edit
                        </b-dropdown-item>
                        <b-dropdown-item
                          v-if="canViewThisAction('delete-exercised-for', 'File')"
                          @click="removeExercisedFor(iu)"
                        >
                          Remove
                        </b-dropdown-item>
                      </b-dropdown>
                    </b-card-header>
                    <b-card-body>
                      <b-button
                        v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                        variant="none"
                        class="weight-600 align-middle not-button text-uppercase"
                      >
                        {{ iu.name }} {{ iu.chineseName }}
                      </b-button>
                      <br>
                      <div
                        v-if="iu.showFullNric"
                        class="my-25"
                      >
                        <span class="text-uppercase mr-50">{{ iu.nric }}</span>
                        <b-button
                          variant="primary"
                          size="sm"
                          class="px-50"
                          @click="iu.showFullNric = false"
                        >
                          Hide full NRIC
                        </b-button>
                      </div>
                      <div
                        v-else
                        class="my-25"
                      >
                        <span class="text-uppercase mr-50">{{ iu.encryptedNric || '-' }}</span>
                        <b-button
                          v-if="canViewThisAction('view-nric', 'NRIC') && iu.nric"
                          variant="primary"
                          size="sm"
                          class="px-50"
                          @click="iu.showFullNric = true"
                        >
                          Show full NRIC
                        </b-button>
                      </div>
                      <span>
                        <b-img
                          height="22"
                          :src="require('@/assets/images/admin/birthday.png')"
                          alt="Left image"
                          class="mr-25 mb-25"
                        />
                        {{ iu.dob ? dateFormat(iu.dob) : '-' }}
                      </span>
                      <br>
                      <span>
                        <b-img
                          height="22"
                          :src="require('@/assets/images/admin/birthday.png')"
                          alt="Left image"
                          class="mr-25 mb-25"
                        />
                        {{ iu.chineseDob || '-' }}
                      </span>
                      <br>
                      <b-table-simple
                        borderless
                        responsive
                        class="particulars_of_deceased d-none d-md-block"
                      >
                        <b-tbody>
                          <b-tr>
                            <b-th width="230px">
                              Exercise date
                            </b-th>
                            <b-td>{{ iu.exerciseDate ? dateFormat(iu.exerciseDate) : '-' }}</b-td>
                          </b-tr>
                          <b-tr>
                            <b-th width="230px">
                              Death Date
                            </b-th>
                            <b-td>{{ iu.dod ? dateFormat(iu.dod) : '-' }}</b-td>
                          </b-tr>
                          <b-tr>
                            <b-th width="230px">
                              Chinese Death Date
                            </b-th>
                            <b-td>{{ iu.chineseDod || '-' }}</b-td>
                          </b-tr>
                          <b-tr>
                            <b-th width="230px">
                              Added on
                            </b-th>
                            <b-td>{{ iu.createdDate ? dateFormat(iu.createdDate) : '-' }}</b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>

                      <hr>

                      <b-table-simple
                        v-if="iu.showMore"
                        borderless
                        responsive
                        class="particulars_of_deceased d-none d-md-block"
                      >
                        <b-tbody>
                          <b-tr>
                            <b-th width="230px">
                              Sex
                            </b-th>
                            <b-td class="text-uppercase">
                              {{ iu.sex || '-' }}
                            </b-td>
                          </b-tr>
                          <!-- <b-tr>
                            <b-th width="230px">
                              Religion
                            </b-th>
                            <b-td class="text-uppercase">
                              {{ iu.religion || '-' }}
                            </b-td>
                          </b-tr> -->
                          <b-tr>
                            <b-th width="230px">
                              Marital Status
                            </b-th>
                            <b-td class="text-uppercase">
                              {{ iu.maritalStatus || '-' }}
                            </b-td>
                          </b-tr>
                          <b-tr>
                            <b-th width="230px">
                              Nationality
                            </b-th>
                            <b-td class="text-uppercase">
                              {{ iu.nationality || '-' }}
                            </b-td>
                          </b-tr>
                          <b-tr>
                            <b-th width="230px">
                              Cremation Cert
                            </b-th>
                            <b-td class="text-uppercase">
                              {{ iu.cremationCertificate || '-' }}
                            </b-td>
                          </b-tr>
                          <b-tr>
                            <b-th width="230px">
                              Reference No.
                            </b-th>
                            <b-td class="text-uppercase">
                              {{ iu.referenceNo || '-' }}
                            </b-td>
                          </b-tr>
                          <b-tr>
                            <b-th width="230px">
                              Funeral Address 1
                            </b-th>
                            <b-td class="text-uppercase">
                              {{ iu.address1 || '-' }}
                            </b-td>
                          </b-tr>
                          <b-tr>
                            <b-th width="230px">
                              Funeral Address 2
                            </b-th>
                            <b-td class="text-uppercase">
                              {{ iu.address2 || '-' }}
                            </b-td>
                          </b-tr>
                          <b-tr>
                            <b-th width="230px">
                              Bury Created By
                            </b-th>
                            <b-td>{{ getBuryCreator(iu) }}</b-td>
                          </b-tr>
                          <b-tr>
                            <b-th width="230px">
                              Bury Created On
                            </b-th>
                            <b-td>{{ iu.buryCreatedDate ? dateFormat(iu.buryCreatedDate) : '-' }}</b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                      <hr v-if="iu.showMore">
                      <b-button
                        v-if="!iu.showMore"
                        class="px-0"
                        variant="link"
                        @click="iu.showMore = true"
                      >
                        View more
                        <feather-icon
                          icon="MoreHorizontalIcon"
                        />
                      </b-button>
                      <b-button
                        v-else
                        class="px-0"
                        variant="link"
                        @click="iu.showMore = false"
                      >
                        View Less
                        <feather-icon
                          icon="MoreHorizontalIcon"
                        />
                      </b-button>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-card-text>
            <div
              v-else
              class="empty_block"
            >
              <h4>No Data Yet</h4>
              <span class="align-middle">Item will show once the data is entered</span>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        md="4"
      >
        <b-card
          class="has-padding"
        >
          <b-card-title>
            Agent Details
          </b-card-title>
          <b-card-body>
            <b-tabs
              v-if="fileInfo.agents && fileInfo.agents.length > 1"
              class="purchaser-tabs"
              content-class="mt-2"
            >
              <b-tab
                v-for="(agent, key) in fileInfo.agents"
                :key="'agent' + key"
                :title="agent.name"
              >
                <b-card-text>
                  <div class="d-flex gap-5">
                    <div>
                      <b-avatar
                        v-if="agent.image"
                        :src="agent.image"
                        size="150px"
                      />
                      <b-avatar
                        v-else
                        :text="resolveAcronymName(agent.name)"
                        size="150px"
                      />
                    </div>
                    <div>
                      <b-badge
                        variant="light-info"
                      >
                        {{ agent.type }}
                      </b-badge>
                      <br>
                      <span>
                        <feather-icon
                          icon="UserIcon"
                          size="22"
                          class="mr-25 iu-icon"
                        />
                        <b-button
                          v-if="canViewThisAction('show', 'Agent') && agent.agent"
                          v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                          variant="link"
                          class="weight-600 align-middle detail-view-id"
                          :to="{ name: 'agency-agents-show', params: { id: agent.agent._id } }"
                        >
                          {{ agent.name }}
                        </b-button>
                        <b-button
                          v-else
                          v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                          variant="none"
                          class="text-bold-black align-middle not-button"
                        >
                          {{ agent.name }}
                        </b-button>
                        ({{ agent.code || '-' }})
                      </span>
                      <br>
                      <span>
                        <feather-icon
                          icon="TabletIcon"
                          size="22"
                          class="mr-25 iu-icon"
                        />
                        <span>
                          {{ agent.contact || '-' }}
                        </span>
                      </span>
                      <p class="agency-text">
                        <span class="text-bold-black">Agency</span>
                        <span class="ml-1">{{ agent.agent ? agent.agent.agencyName : '-' }} ({{ agent.agent ? agent.agent.agencyCode : '-' }}) - {{ agent.agent ? agent.agent.agencyCountry : '-' }}</span>
                      </p>
                    </div>
                  </div>
                  <hr>
                  <p class="agency-text weight-500">
                    Other files under this agent for main purchaser
                  </p>
                  <template v-if="agent.files && agent.files.length">
                    <span
                      v-for="(file, index) in agent.files"
                      :key="'agent-file' + index"
                      class="mr-50 mb-50"
                      style="display: inline-block;"
                    >
                      <b-button
                        :id="'tooltip-0-' + index"
                        variant="primary"
                      >
                        {{ file.fileNo }}
                      </b-button>
                      <b-tooltip
                        :target="'tooltip-0-' + index"
                        triggers="hover"
                        no-fade
                      >
                        <span>{{ file.nvsFileType }}</span>
                        <br>
                        <span>{{ file.lotLocation }}</span>
                      </b-tooltip>
                    </span>
                  </template>
                  <span v-else>-</span>
                </b-card-text>
              </b-tab>
            </b-tabs>
            <b-card-text v-else-if="fileInfo.agents && fileInfo.agents.length">
              <div class="d-flex gap-5">
                <div>
                  <b-avatar
                    v-if="fileInfo.agents[0].image"
                    :src="fileInfo.agents[0].image"
                    size="150px"
                  />
                  <b-avatar
                    v-else
                    :text="resolveAcronymName(fileInfo.agents[0].name)"
                    size="150px"
                  />
                </div>
                <div>
                  <b-badge
                    variant="light-info"
                  >
                    {{ fileInfo.agents[0].type }}
                  </b-badge>
                  <br>
                  <span>
                    <feather-icon
                      icon="UserIcon"
                      size="22"
                      class="mr-25 iu-icon"
                    />
                    <b-button
                      v-if="canViewThisAction('show', 'Agent') && fileInfo.agents[0].agent"
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      variant="link"
                      class="weight-600 align-middle detail-view-id"
                      :to="{ name: 'agency-agents-show', params: { id: fileInfo.agents[0].agent._id } }"
                    >
                      {{ fileInfo.agents[0].name }}
                    </b-button>
                    <b-button
                      v-else
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      variant="none"
                      class="text-bold-black align-middle not-button"
                    >
                      {{ fileInfo.agents[0].name }}
                    </b-button>
                    ({{ fileInfo.agents[0].code || '-' }})
                  </span>
                  <br>
                  <span>
                    <feather-icon
                      icon="TabletIcon"
                      size="22"
                      class="mr-25 iu-icon"
                    />
                    <span>
                      {{ fileInfo.agents[0].contact || '-' }}
                    </span>
                  </span>
                  <p class="agency-text">
                    <span class="text-bold-black">Agency</span>
                    <span class="ml-1">{{ fileInfo.agents[0].agent ? fileInfo.agents[0].agent.agencyName : '-' }} ({{ fileInfo.agents[0].agent ? fileInfo.agents[0].agent.agencyCode : '-' }}) - {{ fileInfo.agents[0].agent ? fileInfo.agents[0].agent.agencyCountry : '-' }}</span>
                  </p>
                </div>
              </div>
              <hr>
              <p class="agency-text weight-500">
                Other files under this agent for main purchaser
              </p>
              <template v-if="fileInfo.agents[0].files && fileInfo.agents[0].files.length">
                <span
                  v-for="(file, index) in fileInfo.agents[0].files"
                  :key="'agent-file' + index"
                  class="mr-50 mb-50"
                  style="display: inline-block;"
                >
                  <b-button
                    :id="'tooltip-0-' + index"
                    variant="primary"
                  >
                    {{ file.fileNo }}
                  </b-button>
                  <b-tooltip
                    :target="'tooltip-0-' + index"
                    triggers="hover"
                    no-fade
                  >
                    <span>{{ file.nvsFileType }}</span>
                    <br>
                    <span>{{ file.lotLocation }}</span>
                  </b-tooltip>
                </span>
              </template>
              <span v-else>-</span>
            </b-card-text>
            <div
              v-else
              class="empty_block"
            >
              <h4>No Data Yet</h4>
              <span class="align-middle">Item will show once the data is entered</span>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle, BCardHeader, BCardBody, BRow, BCol, BTableSimple, BTbody, BTr, BTh, BTd, BButton, VBTooltip, VBToggle,
  BTabs, BTab, BCardText, BDropdown, BDropdownItem, BBadge, BAvatar, BTooltip, BAlert,
  BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import moment from 'moment'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ToastificationContentCustom from '../../operation/ToastificationContentCustom.vue'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BCard,
    BCardTitle,
    BCardHeader,
    BCardBody,
    BImg,
    BRow,
    BCol,
    BTableSimple,
    BTbody,
    BTr,
    BTh,
    BTd,
    BButton,
    BCardText,
    BTabs,
    BTab,
    BDropdown,
    BDropdownItem,
    BBadge,
    BAvatar,
    BTooltip,
    BAlert,
  },
  directives: { 'b-toggle': VBToggle, 'b-tooltip': VBTooltip, Ripple },
  props: {
    fileInfo: {
      type: [Object, null],
      default: () => {},
    },
  },
  data() {
    return {
      relatedLot: {},
      purchasersData: [],
      intendedUsersData: [],
      nextOfKinsData: [],
      addresseeData: [],
      exercisedForData: [],
      showCustomerFullNric: false,
      showIntendedUserFullNric: false,
      showNextOfKinFullNric: false,
      showAddresseeFullNric: false,
    }
  },
  watch: {
    fileInfo: {
      handler(newVal) {
        if (newVal.relatedLots?.length) {
          // eslint-disable-next-line prefer-destructuring
          this.relatedLot = newVal.relatedLots[0]
        }

        this.purchasersData = Array.isArray(newVal.purchasers)
          ? newVal.purchasers.map(item => ({ ...item, showFullNric: false }))
          : []

        this.intendedUsersData = Array.isArray(newVal.intendedUsers)
          ? newVal.intendedUsers.map(item => ({ ...item, showFullNric: false }))
          : []

        this.nextOfKinsData = Array.isArray(newVal.nextOfKins)
          ? newVal.nextOfKins.map(item => ({ ...item, showFullNric: false }))
          : []

        this.addresseeData = Array.isArray(newVal.addressees)
          ? newVal.addressees.map(item => ({ ...item, showFullNric: false }))
          : []

        this.exercisedForData = Array.isArray(newVal.deceased)
          ? newVal.deceased.map(item => ({ ...item, showFullNric: false, showMore: false }))
          : []
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    canViewThisAction,
    resolveAcronymName(name) {
      return name.split(' ').map(item => item.charAt(0)).join('').toUpperCase()
    },
    editUser(user, index) {
      this.$emit('emitIntendedUserEdit', user, index)
    },
    editRemarks() {
      this.$emit('emitRemarksEdit')
    },
    editTransferDate() {
      this.$emit('emitTransferDateEdit')
    },
    allowTransfer() {
      this.$emit('emitAllowTransfer')
    },
    allowExercisedTransfer() {
      this.$emit('emitAllowExercisedTransfer')
    },
    removeUser(user, index) {
      this.$emit('emitIntendedUserRemove', user, index)
    },
    getResidentialAddress(purchaser) {
      if (purchaser.customer) {
        let residentialAddress = ''
        residentialAddress += purchaser.customer.perAddress1 ? purchaser.customer.perAddress1.toUpperCase() : ''
        residentialAddress += purchaser.customer.perAddress2 ? `, ${purchaser.customer.perAddress2.toUpperCase()}` : ''
        residentialAddress += purchaser.customer.perCountry ? `, ${purchaser.customer.perCountry.toUpperCase()}` : ''
        residentialAddress += purchaser.customer.perPostcode ? ` ${purchaser.customer.perPostcode.toUpperCase()}` : ''
        return residentialAddress
      }

      return '-'
    },
    getNomineeResidentialAddress(purchaser) {
      let residentialAddress = ''
      residentialAddress += purchaser.perAddress1 ? purchaser.perAddress1.toUpperCase() : ''
      residentialAddress += purchaser.perAddress2 ? `, ${purchaser.perAddress2.toUpperCase()}` : ''
      residentialAddress += purchaser.perCountry ? `, ${purchaser.perCountry.toUpperCase()}` : ''
      residentialAddress += purchaser.perPostcode ? ` ${purchaser.perPostcode.toUpperCase()}` : ''
      return residentialAddress
    },
    showConfirmAlert(fileType, date) {
      if (!date) return false
      const confirmDate = moment(date)
      return fileType === 'Funeral Service Package' && confirmDate.isAfter(moment().subtract(30, 'days'))
    },
    getBuryCreator(iu) {
      if (iu.createdByNvs) {
        return iu.createdByNvs.name
      }
      if (iu.buryCreatedBy) {
        return iu.buryCreatedBy
      }

      return '-'
    },
    allowExercising() {
      this.$swal({
        title: 'Allow file to be exercised',
        html: 'By default, files with <strong>Book status</strong> cannot be exercised. However, you have the permission to override this restriction. Would you like to allow this file to be exercised anyway?',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/play.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, allow exercising',
        cancelButtonText: 'No, cancel',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.$http.get(`customer/files/${this.fileInfo._id}/allow-exercising`)
              .then(response => {
                if (response.data.success) {
                  this.$toast({
                    component: ToastificationContentCustom,
                    props: {
                      title: 'You’ve allowed exercising',
                      text: 'This file has been successfully modified to enable exercising functionality. The “Exercised For Person” option can now be added.',
                      icon: 'CheckCircleIcon',
                      variant: 'success',
                      hideClose: true,
                    },
                  })
                  this.$emit('emitAllowedExercising', response.data.data)
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                    },
                  })
                }
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
    disallowExercising() {
      this.$swal({
        title: 'Disallow exercising',
        html: `This file has been granted permission to be exercised under Book status by <strong>${this.fileInfo.exercisingAllowedBy ? this.fileInfo.exercisingAllowedBy.name : ''}</strong>. Would you like to revoke this permission?`,
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/play.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, disallow exercising',
        cancelButtonText: 'No, cancel',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.$http.get(`customer/files/${this.fileInfo._id}/disallow-exercising`)
              .then(response => {
                if (response.data.success) {
                  this.$toast({
                    component: ToastificationContentCustom,
                    props: {
                      title: 'You’ve disallowed exercising',
                      text: 'The file has been successfully updated to disallow exercising. The “Exercised For Person” field can no longer be added.',
                      icon: 'CheckCircleIcon',
                      variant: 'success',
                      hideClose: true,
                    },
                  })
                  this.$emit('emitDisallowedExercising')
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                    },
                  })
                }
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
    addExercisedFor() {
      this.$emit('emitExercisedForAdd')
    },
    editExercisedFor(data) {
      this.$emit('emitExercisedForEdit', data)
    },
    removeExercisedFor(data) {
      this.$emit('emitExercisedForRemove', data)
    },
    downloadNoticeOfFullPayment() {
      const formData = new FormData()
      let fileUrl = ''
      const fileName = `Notice of Full Payment - ${this.fileInfo.fileNo}`
      if (this.fileInfo.nvsFileType === 'Pedestal') {
        fileUrl = 'pedestal'
      } else if (this.fileInfo.nvsFileType === 'Funeral Service Package') {
        fileUrl = 'funeral-service'
      } else if (this.fileInfo.nvsFileType === 'Niche') {
        fileUrl = 'niche/multiple'
        // if (this.fileInfo.nvsFileStatus === 'CONFIRM/Exercise') {
        //   fileUrl = 'niche/exercised'
        // } else {
        //   fileUrl = 'niche/multiple'
        // }
      }
      formData.append('url', `${window.location.origin}/certificate/${fileUrl}`)
      formData.append('landscape', true)
      formData.append('pageRanges', 1)
      formData.append('fileID', this.fileInfo._id)

      this.$http.post('customer/files/certificate/download', formData, {
        headers: { Accept: 'application/pdf' },
        responseType: 'arraybuffer',
      })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>
